"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const url_parse_1 = __importDefault(require("url-parse"));
const client_library_1 = require("@seneca/client-library");
const consts_1 = require("../consts");
const constructTransformersString_1 = __importDefault(require("./constructTransformersString"));
function getCdnUrl(imageUrl) {
    const parsedUrl = new url_parse_1.default(imageUrl);
    parsedUrl.set('protocol', consts_1.CDN_URL_PROTOCOL);
    parsedUrl.set('slashes', '//');
    parsedUrl.set('hostname', '');
    parsedUrl.set('port', undefined);
    return parsedUrl.toString();
}
exports.getCdnUrl = getCdnUrl;
function parseCdnUrl(url, baseUrl, options) {
    const parsedBaseUrl = new url_parse_1.default(baseUrl);
    const parsedUrl = new url_parse_1.default(url);
    parsedUrl.set('protocol', parsedBaseUrl.protocol);
    parsedUrl.set('hostname', parsedBaseUrl.hostname);
    parsedUrl.set('port', parsedBaseUrl.port);
    const paramStr = constructTransformersString_1.default(options);
    if (paramStr && paramStr.length) {
        const parsedPathname = /^(.*)\.(.*)$/.exec(parsedUrl.pathname);
        if (!parsedPathname || parsedPathname.length < 3) {
            throw new client_library_1.InvalidParamError('baseUrl', baseUrl, 'Could not parse path and extension from url');
        }
        const [_, path, ext] = parsedPathname;
        parsedUrl.set('pathname', `${path},${paramStr}.${ext}`);
    }
    return parsedUrl.toString();
}
exports.parseCdnUrl = parseCdnUrl;
